import React, { useContext } from 'react';
import './index.scss';
import TypoGraphy from '@/typography';
import { projectImages } from '../../../public/Assets/Images';
import useViewType from '@/utils/Hooks/useViewType';
import Image from 'next/image';
import { AppContext } from '@/contexts/appcontext';
import { gumletLoader } from '@/utils/gumlet';
const SuccessStoryCard = ({
  learnerDetails,
  isModal
}: any) => {
  const isMobile = useViewType();
  const truncateName = (name: string) => {
    let names = name.split(" ");
    if (names.length === 1) return [name];else if (names.length === 2) return names;else if (names.length === 3) return [names[0] + " " + names[1], names[2]];else return [names[0] + " " + names[1], names[2] + " " + names[3]];
  };
  return <div className="learner_card_wrapper" style={isModal ? {
    minWidth: "100% !important"
  } : {}} data-sentry-component="SuccessStoryCard" data-sentry-source-file="index.tsx">
      <div className="learner_card flex flex-col">
        <div className="top_content flex flex-row items-center">
          <div className="photo_wrapper">
            {<Image loader={gumletLoader} width={40} height={40} loading='lazy' src={learnerDetails?.userImageUrl.replace('assets.growthschool.io', 'outskill-mentors.gumlet.io') + "?q=25"} alt="learner" />}
          </div>
          <div className="name_wrapper">
          {truncateName(learnerDetails?.userName).map((item, index) => <div key={'name-index' + index}> <TypoGraphy text={item} variant={isMobile ? 'Mobile/Body 1/M | 16 | 120' : "Desktop/Body 1/M | 16 |120"} /> </div>)}
          </div>
        </div>
        <div className={'middle_content grid'}>
          <div className={'grey_card flex flex-col'}>
            <TypoGraphy text={learnerDetails?.prevDesignation} variant={isMobile ? 'Mobile/Caption/R | 12 | 120' : "Desktop/Body 2/M | 14 |120"} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            <TypoGraphy text={learnerDetails?.prevCompany} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 2/R | 14 |120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
          </div>
          <Image loader={gumletLoader} width={28} height={18} src={isMobile ? projectImages.cardarrowdown : projectImages.cardarrowright} alt="arrow_right" loading='lazy' data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          <div className={'grey_card flex flex-col'}>
            <TypoGraphy text={learnerDetails?.designation} variant={isMobile ? 'Mobile/Caption/R | 12 | 120' : "Desktop/Body 2/M | 14 |120"} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            <TypoGraphy text={learnerDetails?.company} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 2/R | 14 |120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </div>
    </div>;
};
export default SuccessStoryCard;